module.exports = __webpack_public_path__ + "media/src/images/icon/heart-4c240b7af1b95c7bd76a624cd2da40d2.png";